import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { settlementListing, viewSettlement, paySettlement } from "../apis/apiHandler";

export const allSettlements = createAsyncThunk(
    'settlement/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await settlementListing(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewSettlementDetails = createAsyncThunk(
    'settlement/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewSettlement(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

// Single booking settle — payload: { tutor_id, items: [{ booking_order_id, sessions_settled, amount_settled }], payment_mode, reference_number, paid_at, notes }
export const settleBooking = createAsyncThunk(
    'settlement/settle',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await paySettlement(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data ?? error);
        }
    }
)

// Settle all pending — payload: { tutor_id, items: [...all pending bookings], payment_mode, reference_number, paid_at, notes }
export const settleAllBookings = createAsyncThunk(
    'settlement/settleAll',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await paySettlement(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data ?? error);
        }
    }
)

const initialState = {
    loading: false,
    settleLoading: false,
    settlementList: [],
    settlementDetail: {},
    error: null,
    settleError: null,
    addSuccess: false,
};

const SettlementSlice = createSlice({
    name: 'settlement',
    initialState,
    reducers: {
        clearSettleError: (state) => {
            state.settleError = null;
        },
    },
    extraReducers: (builder) => {
        builder

            // ── List ──────────────────────────────────────────────────────────
            .addCase(allSettlements.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(allSettlements.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.settlementList = payload?.data;
            })
            .addCase(allSettlements.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? action.error.message;
            })

            // ── View detail ───────────────────────────────────────────────────
            .addCase(viewSettlementDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewSettlementDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.settlementDetail = payload?.data;
            })
            .addCase(viewSettlementDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? action.error.message;
            })

            // ── Settle single booking ─────────────────────────────────────────
            .addCase(settleBooking.pending, (state) => {
                state.settleLoading = true;
                state.settleError = null;
            })
            .addCase(settleBooking.fulfilled, (state) => {
                state.settleLoading = false;
            })
            .addCase(settleBooking.rejected, (state, action) => {
                state.settleLoading = false;
                state.settleError = action.payload ?? action.error.message;
            })

            // ── Settle all bookings ───────────────────────────────────────────
            .addCase(settleAllBookings.pending, (state) => {
                state.settleLoading = true;
                state.settleError = null;
            })
            .addCase(settleAllBookings.fulfilled, (state) => {
                state.settleLoading = false;
            })
            .addCase(settleAllBookings.rejected, (state, action) => {
                state.settleLoading = false;
                state.settleError = action.payload ?? action.error.message;
            })
    }
})

export const { clearSettleError } = SettlementSlice.actions;
export default SettlementSlice.reducer;